import { UseQueryOptions, queryOptions } from '@tanstack/react-query';
import { getProductDescription } from '~/apis/pms';

export type ProductDescriptionRaw = Awaited<ReturnType<typeof getProductDescription>>;

/** 메루카리 상품설명 원문 조회를 위한 쿼리 옵션 */
type Params = Parameters<typeof getProductDescription>[0] & {
  // ...
};

export const productDescriptionRawOptions = ({ ...params }: Params, options?: Pick<UseQueryOptions, 'enabled'>) => {
  return queryOptions({
    queryKey: ['product', 'getProductDescription', { ...params }],
    queryFn: async () => {
      try {
        return await getProductDescription(params);
      } catch (err) {
        // ...
      }
    },
    select: (response) => response?.data,
    ...options,
  });
};
